import { selectDeviceWidth } from '../../../../redux/features/selectors/uiSelectors.ts';
import { useAppSelector } from '../../../../redux/hooks.ts';
import { Tkv2OrderTableHeaderItem } from './Tkv2OrderTableHeaderItem.tsx';
import { TkOrderListfield, Tkv2SortState } from './types.ts';

export const Tkv2OrderTableHeader = ({
  sortState,
  handleHeaderClick,
}: {
  sortState: Tkv2SortState;
  handleHeaderClick: (field: TkOrderListfield) => void;
}) => {
  const deviceWidth = useAppSelector(selectDeviceWidth);

  if (deviceWidth === 'phone') return null;

  return (
    <div className="order-table-header">
      <Tkv2OrderTableHeaderItem
        title="Address"
        field="address"
        sortState={sortState}
        onClick={handleHeaderClick}
      />
      <Tkv2OrderTableHeaderItem
        title="Property Type"
        field="propertyType"
        sortState={sortState}
        onClick={handleHeaderClick}
      />
      <Tkv2OrderTableHeaderItem
        title="Product Type"
        field="appraisalType"
        sortState={sortState}
        onClick={handleHeaderClick}
      />
      <Tkv2OrderTableHeaderItem
        title="Client"
        field="clientName"
        sortState={sortState}
        onClick={handleHeaderClick}
      />
      <Tkv2OrderTableHeaderItem
        title="Dates"
        field="effectiveDate"
        sortState={sortState}
        onClick={handleHeaderClick}
      />
      <Tkv2OrderTableHeaderItem
        title="Tags"
        field="tags"
        sortState={sortState}
        onClick={handleHeaderClick}
      />
    </div>
  );
};
